import React, { memo, useEffect } from 'react'

import {
  HDatePicker,
  DSelect,
  passParamsThrough
} from '../../../validation/HForm'

const VisaAdd = memo(({
  control,
  register,
  errors,
  reset,
  isLoading,
  country,
  variableValue,
  handleOptions,
  tempEntity
}) => {
  const props = {
    control,
    register,
    errors
  }

  useEffect(() => {
    reset({
      "startDate": tempEntity.startDate?.slice(0, 10),
      "endDate": tempEntity.endDate?.slice(0, 10)
    })
  }, [])
  return (
    passParamsThrough(
      <fieldset>
        <div className="form-element">
          <label className="form-element-label" htmlFor="clientAddCountry">Страна</label>
          <div className="form-element-data combobox">
            <DSelect
              h="true"
              name="country"
              isLoading={isLoading}
              defaultValue={variableValue && variableValue}
              multiple={false}
              options={country}
              handleOptions={handleOptions}
              placeholder="Введите страну" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="startDate">C</label>
              <div className="form-element-data date">
                <HDatePicker h="true" className="input"
                  name="startDate"
                  id="startDate" />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="endDate">По</label>
              <div className="form-element-data date">
                <HDatePicker h="true" className="input"
                  name="endDate"
                  id="endDate" />
              </div>
            </div>
          </div>
        </div>
      </fieldset>, props)
  )
})

export default VisaAdd
